import { STATUS } from "@/data/site";

const STYLES = {
  [STATUS.EXISTING]: "bg-heritage text-ivory border-heritage",
  [STATUS.DEV]: "bg-gold/15 text-gold-deep border-gold",
  [STATUS.PLAN]: "bg-transparent text-heritage/80 border-heritage/30",
};
const DARK = {
  [STATUS.EXISTING]: "bg-ivory text-heritage border-ivory",
  [STATUS.DEV]: "bg-gold text-heritage-deep border-gold",
  [STATUS.PLAN]: "bg-transparent text-ivory border-ivory/60",
};

export const StatusBadge = ({ status, dark = false, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-3 py-1 font-caps text-[11px] tracking-[0.2em] uppercase ${
      dark ? DARK[status] : STYLES[status]
    }`}
  >
    <span className={`h-1.5 w-1.5 rounded-full ${status === STATUS.PLAN ? "border border-current" : "bg-current"}`} />
    {status}
  </span>
);
